import React, { ReactNode, useState } from "react";
import { Nav, NavItem, NavLink } from "reactstrap";
import { IsValidPermissions } from "Routes/AuthProtected";
import ProcurementDashboard from "./ProcurementDashboard";

interface DashboardTabsProps {
  children: ReactNode;
}

const DashboardTabs: React.FC<DashboardTabsProps> = ({ children }) => {
  const [activeTab, setActiveTab] = useState<"current" | "procurement">("current");
  const canViewProcurement = IsValidPermissions(["VIEW_ALL_PURCHASE_DASHBOARD"]);

  return (
    <>
      {canViewProcurement && (
        <Nav className="mb-4 gap-3 p-2 bg-light rounded-3">
          <NavItem>
            <NavLink
              className={`fw-semibold px-4 py-2 rounded-2 cursor-pointer ${
                activeTab === "current" ? "bg-primary text-white shadow-sm" : "bg-white text-primary border"
              }`}
              onClick={() => setActiveTab("current")}
            >
              <i className="ri-shield-check-line me-2" /> Permits Dashboard
            </NavLink>
          </NavItem>
          <NavItem>
            <NavLink
              className={`fw-semibold px-4 py-2 rounded-2 cursor-pointer ${
                activeTab === "procurement" ? "bg-primary text-white shadow-sm" : "bg-white text-primary border"
              }`}
              onClick={() => setActiveTab("procurement")}
            >
              <i className="ri-shopping-bag-3-line me-1" /> Procurement Dashboard
            </NavLink>
          </NavItem>
        </Nav>
      )}
      {activeTab === "procurement" && canViewProcurement ? <ProcurementDashboard /> : children}
    </>
  );
};

export default DashboardTabs;
